export { Sparkle as default } from './Sparkle';
